import { render } from "./PendingSelection.vue?vue&type=template&id=7e51da0a&scoped=true"
import script from "./PendingSelection.vue?vue&type=script&lang=js"
export * from "./PendingSelection.vue?vue&type=script&lang=js"

import "./PendingSelection.vue?vue&type=style&index=0&id=7e51da0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e51da0a"]])

export default __exports__